/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Template_ParagraphInputs */

const en_transcript_export_template_paragraph = /** @type {(inputs: Transcript_Export_Template_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paragraph`)
};

const fr_transcript_export_template_paragraph = /** @type {(inputs: Transcript_Export_Template_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paragraphe`)
};

const de_transcript_export_template_paragraph = /** @type {(inputs: Transcript_Export_Template_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absatz`)
};

const it_transcript_export_template_paragraph = /** @type {(inputs: Transcript_Export_Template_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paragrafo`)
};

const ru_transcript_export_template_paragraph = /** @type {(inputs: Transcript_Export_Template_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абзац`)
};

const es_transcript_export_template_paragraph = /** @type {(inputs: Transcript_Export_Template_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Párrafo`)
};

const zh_cn2_transcript_export_template_paragraph = /** @type {(inputs: Transcript_Export_Template_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`段落`)
};

const ja_transcript_export_template_paragraph = /** @type {(inputs: Transcript_Export_Template_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`段落`)
};

const hi_transcript_export_template_paragraph = /** @type {(inputs: Transcript_Export_Template_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुच्छेद`)
};

const pt_pt2_transcript_export_template_paragraph = /** @type {(inputs: Transcript_Export_Template_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parágrafo`)
};

/**
* | output |
* | --- |
* | "Paragraph" |
*
* @param {Transcript_Export_Template_ParagraphInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_template_paragraph = /** @type {((inputs?: Transcript_Export_Template_ParagraphInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Template_ParagraphInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_template_paragraph(inputs)
	if (locale === "de") return de_transcript_export_template_paragraph(inputs)
	if (locale === "it") return it_transcript_export_template_paragraph(inputs)
	if (locale === "ru") return ru_transcript_export_template_paragraph(inputs)
	if (locale === "es") return es_transcript_export_template_paragraph(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_template_paragraph(inputs)
	if (locale === "ja") return ja_transcript_export_template_paragraph(inputs)
	if (locale === "hi") return hi_transcript_export_template_paragraph(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_template_paragraph(inputs)
	return en_transcript_export_template_paragraph(inputs)
});